export default __webpack_public_path__ + "static/media/close_frame.e97ec214.jpg";